import styled from 'styled-components';
export default styled.div `
  margin: 16px 0 0 0;
  padding: 24px;
  background: #fff;
  @media screen and (max-width: 768px) {
    padding: 24px 8px;
  }
`;



// WEBPACK FOOTER //
// ./src/incab/common/components/AppWrapper.jsx